"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GlossaryDto {
}
exports.GlossaryDto = GlossaryDto;
class GlossaryDetailListDto {
}
exports.GlossaryDetailListDto = GlossaryDetailListDto;
